(function(){var hdr=document.getElementById('hdr');var hero=document.querySelector('.film-grain');function onScroll(){if(!hdr)return;var y=window.scrollY||0;var trigger=hero?Math.max(120,hero.offsetHeight-90):120;hdr.classList.toggle('solid', y>trigger);}window.addEventListener('scroll',onScroll,{passive:true});onScroll();var els=document.querySelectorAll('.reveal');if('IntersectionObserver' in window){var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});els.forEach(function(el){io.observe(el);});}else{els.forEach(function(el){el.classList.add('in');});}})();

/* ===== Nectar accessibility layer (WCAG 2.1 AA) ===== */
(function(){
  if(window.__nectarA11y) return; window.__nectarA11y=true;
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function safe(fn){ try{ fn(); }catch(e){} }
  injectCSS();
  ready(function(){
    safe(radioGroups); safe(gallery); safe(sizeGuide); safe(drawer);
    safe(mobileMenu); safe(banner); safe(headingH1); safe(labels); safe(navLabels); safe(newsletterLabel); safe(pixelIframes); safe(footerLink);
  });

  /* contrast + focus + motion overrides (P3 + P2.10/P2.7) */
  function injectCSS(){
    if(document.getElementById('nectar-a11y-css')) return;
    var css=[
      '.text-inkFaint{color:#6e6459!important}',
      '.text-peachDeep{color:#9c4422!important}',
      '#hdr.solid .navlink.text-peach{color:#9c4422!important}',
      '.nf-bar-mid{color:#6b4a3c!important}',
      '.nf-bar-r,.nf-bar-r a{color:#6b4a3c!important}',
      '.nf-bar-r .nf-cop{opacity:1!important}',
      '.js-quick-add:focus-visible{outline:2px solid #9c4422!important;outline-offset:2px}',
      '.nectar-sr-only{position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}',
      '.rsb-band{position:relative}',
      '.rsb-pause{position:absolute;right:8px;top:50%;transform:translateY(-50%);z-index:3;background:rgba(38,32,26,.6);color:#fff;border:0;border-radius:999px;width:30px;height:30px;cursor:pointer;font-size:12px;line-height:1;display:flex;align-items:center;justify-content:center}',
      '.rsb-pause:focus-visible{outline:2px solid #fff;outline-offset:2px}',
      '@media(prefers-reduced-motion:reduce){.rsb-track{animation:none!important}}'
    ].join('');
    var s=document.createElement('style'); s.id='nectar-a11y-css'; s.textContent=css;
    (document.head||document.documentElement).appendChild(s);
  }

  /* ---- P1.1 size & color pickers as ARIA radiogroups + arrow keys ---- */
  function radioGroups(){
    var root=document.getElementById('ProductRoot'); if(!root) return;
    var groups=[];
    root.querySelectorAll('.pdp-sw, .pdp-chip').forEach(function(btn){ var g=btn.parentElement; if(g && groups.indexOf(g)===-1) groups.push(g); });
    groups.forEach(function(g){
      var isColor=!!g.querySelector('.pdp-sw');
      g.setAttribute('role','radiogroup');
      if(!g.getAttribute('aria-label')) g.setAttribute('aria-label', isColor?'Color':'Size');
      var radios=[].slice.call(g.querySelectorAll('.pdp-sw, .pdp-chip'));
      radios.forEach(function(r){
        r.setAttribute('role','radio');
        sync(r); r.tabIndex = r.classList.contains('on')?0:-1;
        new MutationObserver(function(){ sync(r); r.tabIndex=r.classList.contains('on')?0:-1; }).observe(r,{attributes:true,attributeFilter:['class']});
      });
      if(!radios.some(function(r){return r.classList.contains('on');}) && radios[0]) radios[0].tabIndex=0;
      g.addEventListener('keydown', function(e){ key(e, radios); });
    });
    function sync(r){ r.setAttribute('aria-checked', r.classList.contains('on')?'true':'false'); if(r.classList.contains('soldout')) r.setAttribute('aria-disabled','true'); else r.removeAttribute('aria-disabled'); }
    function key(e, radios){
      var k=e.key;
      if(k===' '||k==='Enter'){ e.preventDefault(); if(document.activeElement && radios.indexOf(document.activeElement)>=0) document.activeElement.click(); return; }
      if(['ArrowRight','ArrowDown','ArrowLeft','ArrowUp'].indexOf(k)===-1) return;
      e.preventDefault();
      var idx=radios.indexOf(document.activeElement); if(idx<0){ idx=radios.findIndex(function(r){return r.classList.contains('on');}); if(idx<0) idx=0; }
      var dir=(k==='ArrowRight'||k==='ArrowDown')?1:-1;
      var t=radios[(idx+dir+radios.length)%radios.length];
      if(t){ t.focus(); t.click(); }
    }
  }

  /* ---- P1.2 + P1.3 gallery ---- */
  function title(){ var h=document.querySelector('#ProductRoot h1'); return h?h.textContent.trim():'Product'; }
  function colorName(){ var c=document.getElementById('pdpColorName'); if(c && c.textContent.trim()) return c.textContent.trim(); var on=document.querySelector('.pdp-sw.on'); return on?(on.getAttribute('data-val')||''):''; }
  function altFor(pos,total){ var b=colorName()?(title()+' in '+colorName()):title(); if(total>1 && pos) b+=' — image '+pos+' of '+total; return b; }
  function gallery(){
    var root=document.getElementById('ProductRoot'); if(!root) return;
    var main=document.getElementById('pdpMain');
    var tw=document.getElementById('pdpThumbs');
    var thumbs=tw?[].slice.call(tw.querySelectorAll('.pdp-thumb')):[];
    var total=thumbs.length||1;
    var region=main?main.closest('.flex'):null;
    if(region){ region.setAttribute('role','region'); region.setAttribute('aria-label','Product images'); region.setAttribute('aria-roledescription','carousel'); if(!region.hasAttribute('tabindex')) region.setAttribute('tabindex','0'); }
    function setAlt(){ if(!main) return; var on=tw?tw.querySelector('.pdp-thumb.on'):null; var pos=on?(thumbs.indexOf(on)+1):1; main.alt=altFor(pos,total); }
    if(main){ setAlt(); new MutationObserver(setAlt).observe(main,{attributes:true,attributeFilter:['src']}); }
    thumbs.forEach(function(t,i){
      t.setAttribute('aria-label','View image '+(i+1)+' of '+total);
      if(t.classList.contains('on')) t.setAttribute('aria-current','true');
      new MutationObserver(function(){ if(t.classList.contains('on')) t.setAttribute('aria-current','true'); else t.removeAttribute('aria-current'); setAlt(); }).observe(t,{attributes:true,attributeFilter:['class']});
    });
    if(region && thumbs.length>1){
      region.addEventListener('keydown', function(e){
        if(e.key!=='ArrowLeft' && e.key!=='ArrowRight') return;
        var sw=document.getElementById('pdpSwipe');
        if(sw && getComputedStyle(sw).display!=='none') return;
        e.preventDefault();
        var ci=thumbs.findIndex(function(t){return t.classList.contains('on');}); if(ci<0) ci=0;
        thumbs[(ci+(e.key==='ArrowRight'?1:-1)+thumbs.length)%thumbs.length].click();
      });
    }
    watchSwipe();
  }
  function watchSwipe(){
    var ex=document.getElementById('pdpSwipe'); if(ex){ enhanceSwipe(ex); return; }
    var mo=new MutationObserver(function(m,obs){ var sw=document.getElementById('pdpSwipe'); if(sw){ enhanceSwipe(sw); obs.disconnect(); } });
    mo.observe(document.body,{childList:true,subtree:true});
    setTimeout(function(){ try{ mo.disconnect(); }catch(e){} }, 9000);
  }
  function enhanceSwipe(sw){
    sw.setAttribute('role','region'); sw.setAttribute('aria-label','Product images'); sw.setAttribute('aria-roledescription','carousel'); if(!sw.hasAttribute('tabindex')) sw.setAttribute('tabindex','0');
    var imgs=[].slice.call(sw.querySelectorAll('img'));
    imgs.forEach(function(im,i){ im.alt=altFor(i+1,imgs.length); });
    sw.addEventListener('keydown', function(e){
      if(e.key!=='ArrowLeft' && e.key!=='ArrowRight') return;
      e.preventDefault();
      var w=sw.clientWidth||1, idx=Math.round(sw.scrollLeft/w);
      idx=Math.max(0,Math.min(imgs.length-1, idx+(e.key==='ArrowRight'?1:-1)));
      sw.scrollTo({left:idx*w, behavior:'smooth'});
    });
  }

  /* ---- P1.5 size guide ---- */
  function sizeGuide(){
    var guide=document.getElementById('pdpGuide'); if(!guide) return;
    var btn=null;
    document.querySelectorAll('#ProductRoot button').forEach(function(b){ var oc=b.getAttribute('onclick')||''; if(oc.indexOf('pdpGuide')>-1 || /size guide/i.test(b.textContent)) btn=b; });
    if(!btn) return;
    btn.setAttribute('aria-controls','pdpGuide');
    btn.setAttribute('aria-expanded', guide.classList.contains('open')?'true':'false');
    new MutationObserver(function(){ btn.setAttribute('aria-expanded', guide.classList.contains('open')?'true':'false'); }).observe(guide,{attributes:true,attributeFilter:['class']});
  }

  /* ---- P1.4 cart drawer ---- */
  function drawer(){
    var d=document.getElementById('ncDrawer'); if(!d) return;
    var live=document.querySelector('[data-cart-live]');
    var lastFocus=null, pending=null, pendingAt=0;
    document.addEventListener('click', function(e){
      var add=e.target.closest && e.target.closest('.js-quick-add, #pdpAddBtn');
      if(!add) return; pending=addLabel(add); pendingAt=Date.now();
    }, true);
    new MutationObserver(function(){
      var open=d.classList.contains('open');
      if(open && !d.__a11y){ d.__a11y=true; onOpen(); }
      else if(!open && d.__a11y){ d.__a11y=false; onClose(); }
    }).observe(d,{attributes:true,attributeFilter:['class']});
    function foci(){ return [].slice.call(d.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function(el){ return el.offsetParent!==null; }); }
    function onOpen(){
      lastFocus=document.activeElement;
      var x=d.querySelector('[data-nc-close]')||d;
      setTimeout(function(){ try{ x.focus(); }catch(e){} }, 60);
      d.addEventListener('keydown', trap);
      if(live && pending && (Date.now()-pendingAt)<5000){ live.textContent=pending; }
      pending=null;
    }
    function onClose(){ d.removeEventListener('keydown', trap); if(lastFocus && lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} } }
    function trap(e){ if(e.key!=='Tab') return; var f=foci(); if(!f.length) return; var a=f[0], b=f[f.length-1]; if(e.shiftKey && document.activeElement===a){ e.preventDefault(); b.focus(); } else if(!e.shiftKey && document.activeElement===b){ e.preventDefault(); a.focus(); } }
  }
  function addLabel(add){
    var name='item', onPdp=(add.id==='pdpAddBtn' || (add.closest && add.closest('#ProductRoot')));
    if(onPdp){ var h=document.querySelector('#ProductRoot h1'); if(h) name=h.textContent.trim(); }
    else { var link=productLink(add); if(link && link.textContent.trim()) name=link.textContent.trim(); }
    var size='';
    if(onPdp){ var sc=document.querySelector('.pdp-chip.on'); if(sc) size=sc.textContent.trim(); }
    return 'Added '+name+(size?(', size '+size):'')+' to your tote.';
  }
  function productLink(el){
    var p=el;
    while(p && p!==document.body){ var a=p.querySelector && p.querySelector('a[href*="/products/"]'); if(a) return a; p=p.parentElement; }
    return null;
  }

  /* ---- P2.6 mobile menu: aria-expanded, inert-when-closed, focus mgmt ---- */
  function mobileMenu(){
    var d=document.getElementById('mdrawer'); if(!d) return;
    var scrim=document.getElementById('mscrim');
    var btn=null;
    document.querySelectorAll('button[aria-label="Menu"]').forEach(function(b){ if((b.getAttribute('onclick')||'').indexOf('mdrawer')>-1) btn=b; });
    if(btn){ if(!d.id) d.id='mdrawer'; btn.setAttribute('aria-controls','mdrawer'); btn.setAttribute('aria-expanded','false'); }
    var last=null;
    function isOpen(){ return d.classList.contains('open'); }
    function closed(){ d.setAttribute('aria-hidden','true'); try{ d.inert=true; }catch(e){} if(btn) btn.setAttribute('aria-expanded','false'); }
    function opened(){ d.removeAttribute('aria-hidden'); try{ d.inert=false; }catch(e){} if(btn) btn.setAttribute('aria-expanded','true'); }
    if(!isOpen()) closed();
    function close(){ d.classList.remove('open'); if(scrim) scrim.classList.remove('open'); }
    new MutationObserver(function(){
      var open=isOpen();
      if(btn) btn.setAttribute('aria-expanded', open?'true':'false');
      if(open && !d.__mo){ d.__mo=true; opened(); last=document.activeElement; var cx=d.querySelector('button[aria-label="Close"]')||d; setTimeout(function(){ try{ cx.focus(); }catch(e){} },60); d.addEventListener('keydown', keyer); }
      else if(!open && d.__mo){ d.__mo=false; d.removeEventListener('keydown', keyer); closed(); if(last && last.focus){ try{ last.focus(); }catch(e){} } }
    }).observe(d,{attributes:true,attributeFilter:['class']});
    function keyer(e){
      if(e.key==='Escape'){ e.preventDefault(); close(); return; }
      if(e.key!=='Tab') return;
      var f=[].slice.call(d.querySelectorAll('a[href],button:not([disabled]),input,summary,[tabindex]:not([tabindex="-1"])')).filter(function(el){ return el.offsetParent!==null; });
      if(!f.length) return; var a=f[0], b=f[f.length-1];
      if(e.shiftKey && document.activeElement===a){ e.preventDefault(); b.focus(); }
      else if(!e.shiftKey && document.activeElement===b){ e.preventDefault(); a.focus(); }
    }
  }

  /* ---- P2.7 scrolling banner: pause/play, hover/focus pause, reduced motion ---- */
  function banner(){
    attach(); if(!document.querySelector('.rsb-band')){ var mo=new MutationObserver(function(m,obs){ if(document.querySelector('.rsb-band')){ attach(); obs.disconnect(); } }); mo.observe(document.body,{childList:true,subtree:true}); setTimeout(function(){ try{ mo.disconnect(); }catch(e){} },9000); }
    function attach(){
      var band=document.querySelector('.rsb-band'), track=document.querySelector('.rsb-track');
      if(!band || !track || band.__a11y) return; band.__a11y=true;
      var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var userPaused=!!reduce;
      function apply(){ track.style.animationPlayState=userPaused?'paused':'running'; }
      var btn=document.createElement('button'); btn.type='button'; btn.className='rsb-pause';
      function lbl(){ btn.setAttribute('aria-label', userPaused?'Play announcements':'Pause announcements'); btn.textContent=userPaused?'▶':'⏸'; }
      btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); userPaused=!userPaused; apply(); lbl(); });
      band.appendChild(btn); lbl(); apply();
      band.addEventListener('mouseenter', function(){ if(!userPaused) track.style.animationPlayState='paused'; });
      band.addEventListener('mouseleave', function(){ if(!userPaused) track.style.animationPlayState='running'; });
      band.addEventListener('focusin', function(){ if(!userPaused) track.style.animationPlayState='paused'; });
      band.addEventListener('focusout', function(){ if(!userPaused) track.style.animationPlayState='running'; });
    }
  }

  /* ---- P2.8 homepage H1 ---- */
  function headingH1(){
    if(!document.body.classList.contains('template-index')) return;
    var main=document.getElementById('MainContent')||document.querySelector('main'); if(!main) return;
    if(main.querySelector('h1')) return;
    var h=document.createElement('h1'); h.className='nectar-sr-only'; h.textContent='Nectar Clothing — Women’s & Juniors Fashion, Designed in California';
    main.insertBefore(h, main.firstChild);
  }

  /* ---- P2.9 wishlist hearts + quick-add labels (aria-pressed + product name) ---- */
  function labels(){
    var pt=title();
    var pdpHeart=document.querySelector('#ProductRoot .heart, #ProductRoot button[aria-label="Save to wishlist"]');
    if(pdpHeart){
      var s=function(){ var on=pdpHeart.classList.contains('on'); pdpHeart.setAttribute('aria-pressed', on?'true':'false'); pdpHeart.setAttribute('aria-label', (on?'Remove ':'Save ')+(pt||'this item')+(on?' from wishlist':' to wishlist')); };
      s(); new MutationObserver(s).observe(pdpHeart,{attributes:true,attributeFilter:['class']});
    }
    document.querySelectorAll('.js-quick-add').forEach(function(b){
      if(b.id==='pdpAddBtn' || b.getAttribute('data-a11y')) return;
      var link=productLink(b); var name=link?(link.textContent.trim()||link.getAttribute('aria-label')||''):'';
      if(!name) return;
      var sz=b.getAttribute('data-size')||'';
      b.setAttribute('aria-label',(sz?('Add '+name+', size '+sz):('Quick add '+name))+' to tote');
      b.setAttribute('data-a11y','1');
    });
    document.querySelectorAll('.heart, button[aria-label="Save to wishlist"], [data-wish]').forEach(function(b){
      if(b.getAttribute('data-a11y') || b.closest('#ProductRoot') || b.hasAttribute('data-wish-btn')) return;
      var link=productLink(b); var name=link?(link.textContent.trim()||''):'';
      if(!name) return;
      b.setAttribute('data-a11y','1');
      var s2=function(){ var on=b.classList.contains('on'); b.setAttribute('aria-pressed', on?'true':'false'); b.setAttribute('aria-label',(on?'Remove ':'Save ')+name+(on?' from wishlist':' to wishlist')); };
      s2(); new MutationObserver(s2).observe(b,{attributes:true,attributeFilter:['class']});
    });
  }

  /* ---- P2.12 nav landmark labels ---- */
  function navLabels(){
    document.querySelectorAll('nav').forEach(function(n){
      if(n.getAttribute('aria-label') || n.getAttribute('aria-labelledby')) return;
      var txt=(n.textContent||'').replace(/\s+/g,' ').trim();
      if(/^home\s*\//i.test(txt)){ n.setAttribute('aria-label','Breadcrumb'); return; }
      if(n.className && /pagination/i.test(n.className)){ n.setAttribute('aria-label','Pagination'); return; }
    });
    document.querySelectorAll('.nfoot nav').forEach(function(n){ if(n.getAttribute('aria-label')) return; var h=n.querySelector('.nf-h'); n.setAttribute('aria-label', h?('Footer: '+h.textContent.trim()):'Footer'); });
    document.querySelectorAll('nav.pagination, .pagination nav, nav[class*="pagination"], [class*="pagination"] > nav').forEach(function(n){ if(!n.getAttribute('aria-label')) n.setAttribute('aria-label','Pagination'); });
  }

  /* ---- P2.11 newsletter visible label ---- */
  function newsletterLabel(){
    document.querySelectorAll('input[type="email"]').forEach(function(inp){
      var id=inp.id, has=false;
      try{ if(id && document.querySelector('label[for="'+(window.CSS&&CSS.escape?CSS.escape(id):id)+'"]')) has=true; }catch(e){}
      if(inp.closest('label')) has=true;
      if(has) return;
      if(!id){ id='nectar-email-'+Math.random().toString(36).slice(2,8); inp.id=id; }
      var lab=document.createElement('label'); lab.setAttribute('for', id);
      lab.textContent=inp.getAttribute('aria-label') || 'Email address';
      lab.style.cssText='display:block;font-size:.78rem;font-weight:600;letter-spacing:.04em;margin:0 0 .35rem;color:#5b5a59';
      var wrap=inp.closest('.nf-news-f, .input')||inp;
      if(wrap.parentNode) wrap.parentNode.insertBefore(lab, wrap);
    });
  }

  /* ---- Accessibility Statement footer link ---- */
  function footerLink(){
    document.querySelectorAll('.nfoot a, footer a').forEach(function(a){
      if((a.textContent||'').trim().toLowerCase()==='accessibility'){ a.setAttribute('href','/pages/accessibility'); }
    });
  }

  /* ---- P2.13 hidden pixel iframes: title + aria-hidden ---- */
  function pixelIframes(){
    function fix(f){ if(!f || f.tagName!=='IFRAME') return; var hidden=(f.offsetParent===null)||(f.clientWidth<=1&&f.clientHeight<=1)||/pixel|web-pixel|shopify|beacon|analytics/i.test((f.name||'')+' '+(f.src||'')+' '+(f.title||'')); if(!hidden) return; if(!f.getAttribute('title')) f.setAttribute('title','Analytics (no visible content)'); f.setAttribute('aria-hidden','true'); f.setAttribute('tabindex','-1'); }
    document.querySelectorAll('iframe').forEach(fix);
    new MutationObserver(function(muts){ muts.forEach(function(m){ [].forEach.call(m.addedNodes||[], function(n){ if(n.tagName==='IFRAME') fix(n); else if(n.querySelectorAll) n.querySelectorAll('iframe').forEach(fix); }); }); }).observe(document.body,{childList:true,subtree:true});
  }
})();
